import React, { useEffect } from "react";
import "@/App.css";

const WHATSAPP_NUMBER = "351938922843";
const WHATSAPP_MESSAGE = "Hi Rita, I saw your ad and I'm interested in Algarve villas.";
const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

// Minimal Europe Map with distances from Algarve
const EuropeMap = () => (
  <svg viewBox="0 0 320 200" className="w-full max-w-sm mx-auto" style={{ height: 'auto' }}>
    {/* Background */}
    <rect width="320" height="200" fill="#fafafa" rx="8" />
    
    {/* Connection lines from Algarve */}
    <line x1="65" y1="145" x2="95" y2="65" stroke="#2ECC40" strokeWidth="1.5" strokeDasharray="4,3" opacity="0.6" />
    <line x1="65" y1="145" x2="145" y2="95" stroke="#2ECC40" strokeWidth="1.5" strokeDasharray="4,3" opacity="0.6" />
    <line x1="65" y1="145" x2="195" y2="85" stroke="#2ECC40" strokeWidth="1.5" strokeDasharray="4,3" opacity="0.6" />
    <line x1="65" y1="145" x2="260" y2="75" stroke="#2ECC40" strokeWidth="1.5" strokeDasharray="4,3" opacity="0.6" />
    
    {/* City dots */}
    <circle cx="95" cy="65" r="4" fill="#999" />
    <circle cx="145" cy="95" r="4" fill="#999" />
    <circle cx="195" cy="85" r="4" fill="#999" />
    <circle cx="260" cy="75" r="4" fill="#999" />
    
    {/* Algarve pin - larger */}
    <circle cx="65" cy="145" r="12" fill="#2ECC40" />
    <circle cx="65" cy="145" r="5" fill="white" />
    
    {/* City labels with distances */}
    <text x="95" y="55" textAnchor="middle" fontSize="11" fill="#333" fontWeight="500">London</text>
    <text x="95" y="80" textAnchor="middle" fontSize="9" fill="#2ECC40">2h 45m</text>
    
    <text x="145" y="85" textAnchor="middle" fontSize="11" fill="#333" fontWeight="500">Paris</text>
    <text x="145" y="110" textAnchor="middle" fontSize="9" fill="#2ECC40">2h 30m</text>
    
    <text x="195" y="75" textAnchor="middle" fontSize="11" fill="#333" fontWeight="500">Frankfurt</text>
    <text x="195" y="100" textAnchor="middle" fontSize="9" fill="#2ECC40">3h</text>
    
    <text x="260" y="65" textAnchor="middle" fontSize="11" fill="#333" fontWeight="500">Dubai</text>
    <text x="260" y="90" textAnchor="middle" fontSize="9" fill="#2ECC40">7h</text>
    
    {/* Algarve label */}
    <text x="65" y="172" textAnchor="middle" fontSize="12" fill="#1a1a1a" fontWeight="600">Algarve</text>
    <text x="65" y="186" textAnchor="middle" fontSize="9" fill="#666">Faro Airport</text>
  </svg>
);

function App() {
  useEffect(() => {
    // Hide Emergent badge
    const badge = document.getElementById('emergent-badge');
    if (badge) badge.style.display = 'none';
    
    // Google Ads Conversion Event
    if (window.gtag) {
      window.gtag('event', 'conversion', {'send_to': 'AW-17890995190/FklzCJmIvuobEPbXi9NC'});
    }
  }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="app-container">
      
      {/* Top Bar */}
      <header className="flex items-center justify-between px-4 py-3 border-b border-gray-100">
        <span 
          className="text-xl font-semibold tracking-tight text-black"
          style={{ fontFamily: 'Georgia, serif' }}
        >
          ARKEO
        </span>
        <span className="text-xs text-gray-400 tracking-wide">
          Direct from Developer
        </span>
      </header>

      {/* Hero Image - Full */}
      <div className="w-full">
        <img 
          src="https://a0.muscache.com/im/pictures/hosting/Hosting-U3RheVN1cHBseUxpc3Rpbmc6MTI3NTE4MzQwMDE2NTMxNzYyMQ==/original/79bcd15d-0e6b-4a92-ba08-84a75e30f5d0.jpeg"
          alt="Luxury Algarve Villa"
          className="w-full aspect-[16/10] object-cover"
          loading="eager"
        />
      </div>

      {/* Main Content */}
      <main className="px-4 py-5">
        
        {/* Headline */}
        <h1 
          className="text-[28px] sm:text-4xl font-semibold text-black leading-tight mb-1"
          style={{ fontFamily: 'Georgia, serif' }}
          data-testid="headline"
        >
          Your Home Base in Europe.
        </h1>
        
        {/* Subline */}
        <p className="text-gray-500 text-base mb-4">
          Algarve, Portugal — Villas from €500K
        </p>

        {/* Trust Lines - Compact */}
        <div className="space-y-2 mb-5 text-[13px]">
          <div className="flex items-center gap-2 text-gray-600">
            <span>📍</span>
            <span>2h Lisbon · 5h London · 10 min Faro Airport</span>
          </div>
          <div className="flex items-center gap-2 text-gray-600">
            <span>🇪🇺</span>
            <span>EU Member State · Full Residency Rights</span>
          </div>
          <div className="flex items-center gap-2 text-gray-600">
            <span>🏠</span>
            <span>Direct from Developer · No Agent Fees</span>
          </div>
        </div>

        {/* WhatsApp CTA Block - THE HERO MOMENT */}
        <div className="bg-gray-50 rounded-xl p-4 mb-5" data-testid="whatsapp-cta">
          <div className="flex items-center gap-3 mb-3">
            {/* Rita's Photo */}
            <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
              <img 
                src="https://customer-assets.emergentagent.com/job_algarve-invest/artifacts/k7sfgh1b_image.png"
                alt="Rita - Sales Director"
                className="w-full h-full object-cover"
                loading="eager"
              />
            </div>
            <div>
              <p className="font-semibold text-black text-[15px]">Talk to Rita — Sales Director</p>
              <p className="text-xs text-gray-500">Usually replies within minutes</p>
            </div>
          </div>
          
          <a 
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="whatsapp-button"
            className="flex items-center justify-center gap-2 w-full py-3.5 bg-[#2ECC40] hover:bg-[#27ae36] active:bg-[#229a33] text-white font-semibold text-base rounded-lg transition-colors"
          >
            <span>💬</span>
            <span>Chat on WhatsApp</span>
          </a>
        </div>

        {/* Static Map - Below CTA */}
        <div className="mb-4">
          <EuropeMap />
        </div>

      </main>

      {/* Footer */}
      <footer className="px-4 py-5 border-t border-gray-100 text-center">
        <p className="text-sm text-gray-500 mb-1">
          ARKEO · Algarve, Portugal · arkeosales.com
        </p>
        <p className="text-xs text-gray-400">
          All prices indicative. Subject to availability.
        </p>
      </footer>

    </div>
  );
}

export default App;
